module.exports = __webpack_public_path__ + "img/运营.5e589176.png";